import { request } from "../utils/request.js"


export const preCollectOrder_exportForManage = (pojo, args) => request({
    url: 'preCollectOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const preCollectOrder_findPageForManage = (pojo, args) => request({
    url: 'preCollectOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const preCollectOrder_findPageListForManage = (pojo, args) => request({
    url: 'preCollectOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const preCollectOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'preCollectOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const preCollectOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'preCollectOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const preCollectOrder_findPageForSelect = (pojo, args) => request({
    url: 'preCollectOrder/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const preCollectOrder_findPageListForSelect = (pojo, args) => request({
    url: 'preCollectOrder/findPageListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const preCollectOrder_saveIntoDraft = (pojo, args) => request({
    url: 'preCollectOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const preCollectOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'preCollectOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const preCollectOrder_update = (pojo, args) => request({
    url: 'preCollectOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const preCollectOrder_updateAndSubmit = (pojo, args) => request({
    url: 'preCollectOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const preCollectOrder_submitById = (id, args) => request({
    url: 'preCollectOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const preCollectOrder_deleteById = (id, args) => request({
    url: 'preCollectOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const preCollectOrder_approval = (pojo, args) => request({
    url: 'preCollectOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const preCollectOrder_findById = (id, args) => request({
    url: 'preCollectOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/preCollectOrder.js